import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AktifButtonComponent } from './aktif-button.component';

@NgModule({
  declarations: [AktifButtonComponent],
  imports: [
    CommonModule,
  ],
  exports: [AktifButtonComponent],
})
export class AktifButtonModule {
  getComponent() {
    return AktifButtonComponent;
  }
}
